import LoadingSpinner from "../../Components/LoadingSpinner";
import { useTranslation } from "react-i18next";
import BalanceItem from "./BalanceItem";
import { useParams } from "../../../Providers/ParamsProvider";

const BalanceItems = ({ items, isLoading }) => {
    const { t } = useTranslation();
    const { isMobile } = useParams()
    return (

        <div className="main-container-holder mt-2">
            <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Rozkład należności/zobowiązań w czasie</label>
            <div className="table-responsive mt-2">
                <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                    <thead>
                        <tr>
                            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '12%' }}>ZAKRESY</th>
                            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '22%', textAlign: 'right' }}>NALEŻNOŚCI</th>
                            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '22%', textAlign: 'right' }}>ILOŚĆ</th>
                            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '22%', textAlign: 'right' }}>ZOBOWIĄZANIA</th>
                            <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '22%', textAlign: 'right' }}>ILOŚĆ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!isLoading && items &&
                            [...items].reverse().map((item, index) => {
                                return <BalanceItem key={index} item={item} />;
                            })}
                    </tbody>
                </table>
                {isLoading && <LoadingSpinner width={2} height={2} />}
                {!isLoading && items && items.length === 0 && (
                    <div style={{ textAlign: "center" }}>
                        {t("message_norecords_table_invoices_items_page")}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BalanceItems;
